<template>
	<div class="content">
		<div class="row animated fadeIn">
			<div class="col-12">
				<Alert :type="alertType" :message="alertMessage" v-if="alertShow === true" />
				<div class="card" v-if="asyncDone === false">
					<!-- Show the loader when async operation is going on -->
					<div class="loader"></div>
					<h4 style="text-align: justify;padding-left: 20px; padding-right: 20px">{{asyncText}}</h4>
				</div>
			</div>
			<div class="col-12 view-details-wrapper" v-if="asyncDone">
				<div class="card">
					<div class="card-header mt-4">
						<h4 class="card-title d-inline-block mr-4 ml-4 view-details-title">Site:</h4>
						<select class="d-inline-block form-control-sm" data-live-search="true" data-width="fit" v-model="domainIndex">
							<option v-for="(domain, index) in domainList" :disabled="!adminDtls && domain.status === 'pending'" :key="index" :value="index">{{ domain.domain }}</option>
						</select>
					</div>
					<div class="card-body pl-5 pr-5">
						<div class="row">
							<div class="col-6">
								<div class="d-inline-block mr-2" :class="{ 'square-live' : envType === 'live', 'square-staging' : envType === 'staging' }"></div>
								<div class="d-inline-block env-name-top">{{ envType }} Environment</div>
								<p>Hosting details of the {{ envType }} environment</p>
							</div>
							<div class="col-6">
								<div class="float-right" v-if="$route.query.tab !== 'dns'">
									<div class="form-group">
										<label for="changeEnv" class="mr-3">Change Environment</label>
										<select class="form-control-sm" id="changeEnv" v-model="envType">
											<option value="live">Live Environment</option>
											<option value="staging" :disabled="exactDomain.staging && exactDomain.staging.enabled === false">Staging Environment</option>
										</select>
										<button type="button" @click="createStaging(exactDomain.domain)" style="margin-left: 10px" v-if="exactDomain.staging && exactDomain.staging.enabled === false && envType === 'live'" :disabled="stagingRequested" class="btn btn-outline-primary btn-round btn-sm">
											<div class="loader small_loader" v-if="stagingRequested"></div>
											<span v-else>
												Create Staging
											</span>
										</button>
										<button type="button" @click="pushToStaging(exactDomain.domain)" style="margin-left: 10px" v-if="exactDomain.staging && exactDomain.staging.enabled === true && envType === 'live'" :disabled="stagingRequested" class="btn btn-outline-primary btn-round btn-sm">
											<div class="loader small_loader" v-if="stagingRequested"></div>
											<span v-else>
												Push To Staging
											</span>
										</button>
										<button type="button" @click="pushToLive()" style="margin-left: 10px" v-if="envType === 'staging'" :disabled="pushToLiveRequested" class="btn btn-outline-primary btn-round btn-sm">
											<div class="loader small_loader" v-if="pushToLiveRequested"></div>
											<span v-else>
												Push To Live
											</span>
										</button>
                    <button type="button" v-if="exactDomain.staging && exactDomain.staging.enabled === true && envType === 'staging'"  data-toggle="tooltip" data-placement="top" title="Remove Staging" @click="removeStagingDomain(exactDomain)" style="margin-left: 10px" :disabled="removeStagingRequested" class="btn btn-outline-danger btn-round btn-sm">
                      <div class="loader small_loader" v-if="removeStagingRequested"></div>
                      <span v-else>
												Remove Staging
											</span>
                    </button>
									</div>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-sm-12 col-md-2 mb-2">
								<div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
									<a :class="{'nav-link': true, 'active': $route.query.tab === undefined || $route.query.tab === 'info'}"  @click="changeTab('info')"  id="v-pills-info-tab" data-toggle="pill" href="#v-pills-info" role="tab" aria-controls="v-pills-info" aria-selected="true">Info</a>
									<a :class="{'nav-link': true}"  @click="changeTab('wordpress')"  id="v-pills-wordpress-tab"  href="javascript:void(0)"  >WordPress</a>
									<a v-if="openWordPressTabs" :class="{'nav-link': true, 'active':  $route.query.tab === 'admin_users','ml-3':openWordPressTabs}"  @click="changeTab('admin_users')"  id="v-pills-admin-users-tab" data-toggle="pill" href="#v-pills-admin-users" role="tab" aria-controls="v-pills-users" aria-selected="false">Admin Users</a>
									<a v-if="openWordPressTabs" :class="{'nav-link': true, 'active':  $route.query.tab === 'plugins','ml-3':openWordPressTabs}"  @click="changeTab('plugins')"  id="v-pills-plugins-tab" data-toggle="pill" href="#v-pills-plugins" role="tab" aria-controls="v-pills-plugins" aria-selected="false">Plugins</a>
									<a :class="{'nav-link': true, 'active': $route.query.tab === 'domains'}"  @click="changeTab('domains')"  id="v-pills-info-domains" data-toggle="pill" href="#v-pills-domains" role="tab" aria-controls="v-pills-domains" aria-selected="true">Domains</a>
									<a :class="{'nav-link': true, 'active': $route.query.tab === 'backups'}" @click="changeTab('backups')" id="v-pills-backup-tab" data-toggle="pill" href="#v-pills-backup" role="tab" aria-controls="v-pills-backup" aria-selected="false">Backups</a>
									<a v-if="hasCloudflareSettings()" :class="{'nav-link': true, 'active': $route.query.tab === 'traffic'}" @click="changeTab('traffic')" id="v-pills-traffic-tab" data-toggle="pill" href="#v-pills-traffic" role="tab" aria-controls="v-pills-traffic" aria-selected="false">Traffic</a>
									<a :class="{'nav-link': true, 'active': $route.query.tab === 'redirects'}" @click="changeTab('redirects')" id="v-pills-redirects-tab" data-toggle="pill" href="#v-pills-redirects" role="tab" aria-controls="v-pills-redirects" aria-selected="false">Redirects</a>
									<a v-if="hasCloudflareSettings()" :class="{'nav-link': true, 'active': $route.query.tab === 'dns'}" @click="changeTab('dns')" id="v-pills-dns-tab" data-toggle="pill" href="#v-pills-dns" role="tab" aria-controls="v-pills-dns" aria-selected="false">DNS records</a>
									<a :class="{'nav-link': true, 'active': $route.query.tab === 'cache'}" @click="changeTab('cache')" id="v-pills-cache-tab" data-toggle="pill" href="#v-pills-cache" role="tab" aria-controls="v-pills-cache" aria-selected="false">Clear cache</a>
                  <a :class="{'nav-link': true}"  id="v-pills-usage-tab"  href="javascript:void(0)"  >Security</a>
                  <a :class="{'nav-link': true, 'active': $route.query.tab === 'admin-lock', 'ml-3':true}" @click="changeTab('admin-lock')" id="v-pills-admin-lock-tab" data-toggle="pill" href="#v-pills-admin-lock" role="tab" aria-controls="v-pills-admin-lock" aria-selected="false">Login Lock</a>
                  <a :class="{'nav-link': true, 'active': $route.query.tab === 'block-ips', 'ml-3':true}" @click="changeTab('block-ips')" id="v-pills-block-ips-tab" data-toggle="pill" href="#v-pills-block-ips" role="tab" aria-controls="v-pills-block-ips" aria-selected="false">Block IPs</a>
                  <a v-if="hasCloudflareSettings()" :class="{'nav-link': true, 'active': $route.query.tab === 'ssl'}" @click="changeTab('ssl')" id="v-pills-ssl-tab" data-toggle="pill" href="#v-pills-ssl" role="tab" aria-controls="v-pills-ssl" aria-selected="false">SSL</a>
									<a :class="{'nav-link': true}"  id="v-pills-util-tab"  href="javascript:void(0)"  >Utilities</a>
									<a :class="{'nav-link': true, 'active': $route.query.tab === 'tools', 'ml-3':true}" @click="changeTab('tools')" id="v-pills-tools-tab" data-toggle="pill" href="#v-pills-tools" role="tab" aria-controls="v-pills-tools" aria-selected="false">Tools</a>
									<a :class="{'nav-link': true, 'active': $route.query.tab === 'logs', 'ml-3':true}" @click="changeTab('logs')" id="v-pills-logs-tab" data-toggle="pill" href="#v-pills-logs" role="tab" aria-controls="v-pills-logs" aria-selected="false">PHP Error Logs</a>
<!--                  <a v-if="exactDomain.type === 'Primary Domain' && envType === 'live'" :class="{'nav-link': true}"  id="v-pills-usage-tab"  href="javascript:void(0)"  >Usage</a>-->
<!--                  <a v-if="exactDomain.type === 'Primary Domain' && envType === 'live'" :class="{'nav-link': true, 'active': $route.query.tab === 'diskspace', 'ml-3':true}" @click="changeTab('diskspace')" id="v-pills-diskspace-tab" data-toggle="pill" href="#v-pills-tools" role="tab" aria-controls="v-pills-tools" aria-selected="false">Disk Space</a>-->
                  </div>
							</div>
							<div class="col-sm-12 col-md-10 mb-10">
								<div class="tab-content mt-3" id="v-pills-tabContent">
									<div :class="{'tab-pane fade': true, 'show active': $route.query.tab === undefined || $route.query.tab === 'info'}" id="v-pills-info" role="tabpanel" aria-labelledby="v-pills-info-tab">
										<transition enter-active-class="animated fadeIn faster" leave-active-class="animated fadeOut faster" mode="out-in">
											<LiveDetails :account="exactDomain" envType="live" v-if="envType === 'live'" />
											<StagingDetails :account="exactDomain.staging" envType="staging" v-if="envType === 'staging'" />
										</transition>
									</div>
									<div :class="{'tab-pane fade': true, 'show active': $route.query.tab === 'admin_users'}" id="v-pills-admin-users" role="tabpanel" aria-labelledby="v-pills-admin-users-tab">
										<AdminUsers :account="exactDomain"  :envType="envType" />
									</div>
									<div :class="{'tab-pane fade': true, 'show active': $route.query.tab === 'plugins'}" id="v-pills-plugins" role="tabpanel" aria-labelledby="v-pills-plugins-tab">
										<Plugins :account="exactDomain" :envType="envType" />
									</div>
									<div :class="{'tab-pane fade': true, 'show active': $route.query.tab === 'domains'}" id="v-pills-domains" role="tabpanel" aria-labelledby="v-pills-backup-tab">
										<DomainAliases :account="exactDomain" :envType="envType" />
									</div>
									<div :class="{'tab-pane fade': true, 'show active': $route.query.tab === 'backups'}" id="v-pills-backup" role="tabpanel" aria-labelledby="v-pills-backup-tab">
										<BackupList :account="exactDomain" :envType="envType"></BackupList>
									</div>
									<div v-if="hasCloudflareSettings()" :class="{'tab-pane fade': true, 'show active': $route.query.tab === 'traffic'}" id="v-pills-traffic" role="tabpanel" aria-labelledby="v-pills-traffic-tab">
                    <TrafficList :account="exactDomain"></TrafficList>
									</div>
									<div v-if="hasCloudflareSettings()" :class="{'tab-pane fade': true, 'show active': $route.query.tab === 'dns'}" id="v-pills-dns" role="tabpanel" aria-labelledby="v-pills-dns-tab">
										<DNS :account="exactDomain"></DNS>
									</div>
									<div :class="{'tab-pane fade': true, 'show active': $route.query.tab === 'redirects'}" id="v-pills-redirects" role="tabpanel" aria-labelledby="v-pills-redirects-tab">
										<RedirectList :account="exactDomain" :envType="envType"></RedirectList>
									</div>
									<div :class="{'tab-pane fade': true, 'show active': $route.query.tab === 'cache'}" id="v-pills-cache" role="tabpanel" aria-labelledby="v-pills-cache-tab">
										<ClearCache :account="exactDomain"></ClearCache>
									</div>
									<div v-if="hasCloudflareSettings()" :class="{'tab-pane fade': true, 'show active': $route.query.tab === 'ssl'}" id="v-pills-ssl" role="tabpanel" aria-labelledby="v-pills-ssl-tab">
										<SSL :account="exactDomain"></SSL>
									</div>
									<div :class="{'tab-pane fade': true, 'show active': $route.query.tab === 'tools'}" id="v-pills-tools" role="tabpanel" aria-labelledby="v-pills-tools-tab">
										<Utilities :account="exactDomain" :envType="envType" />
									</div>
									<div :class="{'tab-pane fade': true, 'show active': $route.query.tab === 'logs'}" id="v-pills-logs" role="tabpanel" aria-labelledby="v-pills-logs-tab">
										<ErrorLogList :account="exactDomain" :isCollaborator="false" :envType="envType"  />
									</div>
<!--									<div v-if="exactDomain.type === 'Primary Domain' && envType === 'live'" :class="{'tab-pane fade': true, 'show active': $route.query.tab === 'diskspace'}" id="v-pills-diskspace" role="tabpanel" aria-labelledby="v-pills-diskspace-tab">-->
<!--										<disk-space :account="exactDomain" />-->
<!--									</div>-->
									<div :class="{'tab-pane fade': true, 'show active': $route.query.tab === 'admin-lock'}" id="v-pills-admin-lock" role="tabpanel" aria-labelledby="v-pills-admin-lock-tab">
										<admin-lock :account="exactDomain" :envType="envType" />
									</div>
									<div :class="{'tab-pane fade': true, 'show active': $route.query.tab === 'block-ips'}" id="v-pills-block-ips" role="tabpanel" aria-labelledby="v-pills-block-ips-tab">
										<block-ips :account="exactDomain" />
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {db} from "@/firebase/init";
	import AES from 'crypto-js/aes'
	import CryptoJSCore from 'crypto-js/core'
	import swal from 'sweetalert2'
	import { functions } from '@/firebase/init';
	import adminLogs from "../../../../mixins/adminLogs";
	import moment from "moment-timezone"

	export default {
		name: "viewDetailsPage",
		mixins: [adminLogs],
		props: {
			index: String
		},
		data() {
			return {
        removeStagingRequested: false,
				domainIndex: '',
				envType: 'live',
				openWordPressTabs:true,
				adminDtls: JSON.parse(localStorage.getItem('adminDtls')),
			}
		},
		components: {
			Alert: () => import(/* webpackChunkName: "alert" */ "../../../../components/Alerts.vue"),
			LiveDetails: () => import(/* webpackChunkName: "liveHostingDetails" */ "../../../../components/User/Sites/ViewHostingDetails/LiveHostingDetails.vue"),
			StagingDetails: () => import(/* webpackChunkName: "stageHostingDetails" */ "../../../../components/User/Sites/ViewHostingDetails/StagingDetails.vue"),
			BackupList: () => import(/* webpackChunkName: "stageHostingDetails" */ "../../../../components/User/Backup/BackupList.vue"),
			AdminUsers: () => import(/* webpackChunkName: "stageHostingDetails" */ "../../../../components/User/AdminUsers/AdminUsers"),
			Plugins: () => import(/* webpackChunkName: "stageHostingDetails" */ "../../../../components/User/AdminUsers/Plugins"),
			DomainAliases: () => import(/* webpackChunkName: "stageHostingDetails" */ "../../../../components/User/DomainAliases/Domains.vue"),
			RedirectList: () => import(/* webpackChunkName: "stageHostingDetails" */ "../../../../components/User/Redirect/RedirectList.vue"),
			TrafficList: () => import(/* webpackChunkName: "stageHostingDetails" */ "../../../../components/User/Traffic/TrafficList.vue"),
			DNS: () => import(/* webpackChunkName: "stageHostingDetails" */ "../../../../components/User/Dns/DnsList.vue"),
			ClearCache: () => import(/* webpackChunkName: "stageHostingDetails" */ "../../../../components/User/Sites/Cache/Index.vue"),
			SSL: () => import(/* webpackChunkName: "stageHostingDetails" */ "../../../../components/User/Sites/SSL/Index.vue"),
			Utilities: () => import(/* webpackChunkName: "stageHostingDetails" */ "../../../../components/User/Utilities/Utilities.vue"),
			ErrorLogList: () => import(/* webpackChunkName: "siteList" */ "../../../../components/User/Sites/Logs/ErrorLogList.vue"),
      DiskSpace: () => import(/* webpackChunkName: "siteList" */ "../../../../components/User/Sites/Usage/DiskSpace"),
      AdminLock: () => import(/* webpackChunkName: "siteList" */ "../../../../components/User/Sites/Security/AdminLock"),
      BlockIps: () => import(/* webpackChunkName: "siteList" */ "../../../../components/User/Sites/Security/BlockIps")
		},
		computed: {
			clientID() {
				return this.$store.getters.getCustomerID;
			},
			aesSecret() {
				return this.$store.getters["crypto/aesSecret"];
			},
			asyncDone() {
				return this.$store.getters["async/state"];
			},
			asyncText() {
				return this.$store.getters["async/text"];
			},
			alertType() {
				return this.$store.getters["alert/type"];
			},
			alertMessage() {
				return this.$store.getters["alert/message"];
			},
			alertShow() {
				return this.$store.getters["alert/show"];
			},
			accOrdered() {
				return this.$store.getters["hosting/accountsOrdered"]
			},
			domainList() {
				const accounts = this.accOrdered;
				const domainList = [];
				accounts.forEach(acc => {
					domainList.push({
						domain: acc.domain,
						status: acc.status
					})
				});
				return domainList
			},
			exactDomain() {
				const accounts = this.accOrdered;
				try {
					const exactAcc = JSON.parse(JSON.stringify(accounts[this.domainIndex]));
					if(exactAcc.phpMyAdmin && exactAcc.phpMyAdmin.url){
						exactAcc.phpMyAdmin.url = `https://${exactAcc.phpMyAdmin.popupUsername}:${exactAcc.phpMyAdmin.popupPassword}@${exactAcc.phpMyAdmin.url.replace('https://', '')}`;
					}
					return exactAcc
				}catch (e) {
					console.error(e.message);
				}
			},
			userToken() {
				return this.$store.getters.getUserToken;
			},
			UID(){
				return this.$store.getters.getUID;
			},
			stagingRequested() {
				return this.$store.getters.stagingRequested;
			},
			pushToLiveRequested() {
				return this.$store.getters.pushToLiveRequested;
			},
			user() {
				return this.$store.getters.user;
			}
		},
    watch: {
      envType (value) {
        let query = {}
        if (this.$route.query.tab) {
          query.tab = this.$route.query.tab
        }
        this.$router.replace({ name: 'viewDetails', params: { index: this.index, env: value }, query })
      },
      domainIndex (value) {
        let query = {}
        if (this.$route.query.tab) {
          query.tab = this.$route.query.tab
        }
        this.$router.replace({ name: 'viewDetails', params: { index: this.encryptIndex( value.toString() ), env: this.envType }, query })
      }
    },
		methods: {
		  encryptIndex(index) {
        return AES.encrypt(index, this.aesSecret).toString()
      },
			accIndex(index) {
				if(typeof index === 'undefined') {
					this.domainIndex = ''
				} else {
					const bytes = AES.decrypt( this.index, this.aesSecret )
					this.domainIndex = parseInt( bytes.toString(CryptoJSCore.enc.Utf8) )
				}
			},
			changeTab(tab){
				if(tab ==='wordpress'){
					if(this.$route.query.tab !=='admin_users' && this.$route.query.tab !=='plugins'){
						this.openWordPressTabs = !this.openWordPressTabs;
					}else{
						this.openWordPressTabs = true;
					}
				}else{
					this.$router.replace({
						...this.$router.currentRoute,
						query: {
							tab: tab,
						}
					})
				}

			},
			hasCloudflareSettings(){
				return !(this.exactDomain.cloudflare === undefined ||
						!this.exactDomain.cloudflare.zone_id ||
						this.exactDomain.cloudflare.zone_id === undefined ||
						this.exactDomain.cloudflare.zone_id == 'NA' ||
						this.exactDomain.cloudflare.zone_id == '');

			},
			pushToLive() {
				const self = this;
				let buttonHtml = '<div>' +
						'<div>Please be aware, your live site will be completely overwritten with your staging site. If you have made any updates to your live site since creating your staging site, these updates will be lost. Please consider creating a backup of your live site prior to pushing your staging to live.</div>' +
						'<br/>' +
						'<ul class="list-inline">' +
						'<li><button class="sw_butt1 swal2-styled" style="display: inline-block;background-color: rgb(106, 207, 152); border-left-color: rgb(106, 207, 152); border-right-color: rgb(106, 207, 152);">Proceed and Create Backup</button></li>' +
						'<li><button class="sw_butt2 swal2-styled" style="display: inline-block; background: #e6c652" >Proceed without Creating Backup</button></li>' +
						'<li><button class="sw_butt3 swal2-styled" style="display: inline-block; background-color: rgb(238, 128, 87);">Do Not Proceed</button></li>' +
						'</ul></div>'
				swal({
					title: "Would you like to proceed?",
					html: buttonHtml,
					type: 'question',
					showCancelButton: false,
					showConfirmButton: false,
					onOpen: function () {
						console.log('On Opne');
						/* eslint-disable */
						$('.sw_butt1').on('click',function () {
							console.log('migrate');
							self.proceedWithPushToLive(true);
							swal.close();
						});
						$('.sw_butt2').on('click',function () {
							console.log('no-migrate');
							self.proceedWithPushToLive(false);
							swal.close();
						});
						$('.sw_butt3').on('click',function () {
							console.log('close');
							swal.close();
						});
						/* eslint-enable */
					}
				});
			},
			async proceedWithPushToLive (createBackup) {
				this.$store.commit('updatePushToLiveRequested', true);
				const liveDomain = this.accOrdered[this.domainIndex].domain;
				const stagingDomain = this.accOrdered[this.domainIndex].staging.domain;
				const serverIP = this.accOrdered[this.domainIndex].serverIP;
        this.addLog({
          primaryPlan: 'Account Based Operation',
          message: `User has requested for "Push To Live" for ${liveDomain}.`,
          level: "info"
        });
				let date = moment().tz('America/Chicago').format('YYYY-MM-DD HH:mm:ss');
				let folderName = date.replace(/:/g, '_').replace(' ', 'T');
				this.$store.commit('updateBackupActions', {
					value: date,
					type: 'restore',
					input: true
				});
				await this.$http.post('/clone/queue', {
					ip: serverIP,
					source: stagingDomain,
					destination: liveDomain,
					grant_type: "token",
					token: this.userToken,
					firstName: this.user.firstName,
					lastName: this.user.lastName,
					UID: this.UID,
					createBackup: (createBackup) ? 'true' : 'false',
					backupName: 'manual-' + folderName,
					backupDate: date
				}).then(() => {
					this.$notify({
						group: 'foo',
						title: 'Request Received',
						duration: 3000,
						text: 'We will notify you once we are done with the request',
						type: 'info'
					});
				});
			},
			pushToStaging(domain) {
				swal({
					title: "Overwrite Current Staging?",
					text: 'By pushing to staging, all current data for your Staging site will be overwritten by your live site. Would you like to proceed?',
					type: "question",
					confirmButtonText: "Yes Proceed",
					confirmButtonColor: "#6ACF98",
					showCancelButton: true,
					cancelButtonText: "No Thanks",
					cancelButtonColor: "#EE8057"
				}).then( result => {
					if(result.value){
            this.addLog({
              primaryPlan: 'Account Based Operation',
              name: this.user.firstName + " " + this.user.lastName,
              message: `User has requested for "Push To Staging" for ${domain}.`,
              level: "info"
            });
						console.log('Push To Staging For Domain: ' + domain);
						this.createStaging(domain);
					}
				});
			},
			async createStaging(domain) {
				this.$store.commit('updateStagingRequested', true);
				let finalAccount = null;
				const accountDetails = this.$store.getters['hosting/accounts'];
				let hostingAccountIndex = 0;
				let adOnAccountIndex = 0;
				let isAdOnAccount = false;
				let isAbortSearching = false;
				for(const account of accountDetails){
					adOnAccountIndex = 0;
					if(account.primary.domain === domain){
						finalAccount = account.primary;
						break;
					}
					for(const adon of account.addon){
						if(adon.domain === domain){
							finalAccount = adon;
							isAdOnAccount = true;
							isAbortSearching = true;
							break;
						}
						adOnAccountIndex++;
					}
					if(isAbortSearching){
						break;
					}
					hostingAccountIndex++;
				}
				console.log(finalAccount);
				console.log(domain);
        this.addLog({
          primaryPlan : accountDetails[hostingAccountIndex].primary.domain,
          message: `User has requested for "create staging" for ${domain}.`,
          level: "info"
        })
				this.$http.post('/staging-request/queue', {
					ip: finalAccount.serverIP,
					source: domain,
					destination: domain.replace(/\./g, "") + '.bigscoots-staging.com',
					grant_type: "token",
					token: this.userToken,
					isAdOnAccount: (isAdOnAccount) ? '1' : '0',
					hostingAccountIndex: hostingAccountIndex,
					adOnAccountIndex: adOnAccountIndex,
					UID: this.user.uid,
					firstName: this.user.firstName,
					lastName: this.user.lastName
				}).then(async resp => {
          console.log(resp.data);
				  if (resp.data.alreadyPaused) {
				    let ticketId = resp.data.ticketId;
            let text = resp.data.msg
            if (ticketId) {
              const encryptedId = await this.encryptIndex(ticketId.toString())
              text += ' <a href="/tickets/view/'+ encryptedId +'" style="color:white;"><b>Click here</b></a> to check ticket.'
            }
            console.log(text)
            this.$notify({
              group: 'foo',
              type: 'info',
              title: 'Staging Request',
              duration: -3000,
              text
            });
            this.$store.commit('updateStagingRequested', false);
          } else {
            this.addLog({
              primaryPlan: accountDetails[hostingAccountIndex].primary.domain,
              message: `Staging job has been enqueued! Domain: ${domain}`,
              level: "success"
            })
            this.$notify({
              group: 'foo',
              type: 'info',
              title: 'Staging Request',
              duration: 5000,
              text: 'Your staging request has been submitted, please stand by for it to complete!'
            });
          }
					// const sound = new Audio('/eventually.mp3');
					// sound.play();
				}).catch((err) => {
					//generate ticket here...
					this.createTicketIfFailed(domain);
					this.addLog({
						name: this.user.firstName + " " + this.user.lastName,
						message: "Error in enqueuing Staging Request for domain: "+domain+". Message: " + err.response.data.message,
						level: "error"
					});
				});
			},
			createTicketIfFailed(domain){
				const errorAlert = functions.httpsCallable("stagingErrorAlert")
				errorAlert({
					clientID: this.clientID,
					domain: domain
				}).then(response => {
					this.$store.dispatch("async/stateUpdate", { state: true, text: '' })
					if(response.data.success) {
						swal({
							title: "Staging Failed!",
							text: response.data.message,
							type: "warning",
							confirmButtonText: "OK",
							confirmButtonColor: "#EE8057"
						})
					} else {
						swal({
							title: "Something went wrong!",
							text: response.data.message,
							type: "error",
							confirmButtonText: "Try Again!",
							confirmButtonColor: "#EE8057"
						})
					}
				})
			},
      async removeStagingDomain (account) {
        let staging = account.staging;
        console.log(staging);
        // First confirm the user if he truly wants to delete this domain
        const resp = await swal({
          title: "Are you sure?",
          text: `Please confirm that you would like to remove  ${staging.domain} domain permanently.`,
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        })
        if (resp.value) {
          try {
            this.removeStagingRequested = true;
            this.addLog({
              primaryPlan : staging.addonPrimaryPlan,
              message: 'Requested to remove staging domain: ' + staging.domain,
              level: "info"
            });
            const res = await this.$http.post('staging-request/remove', {
              domain: staging.domain,
              ip: staging.ftp.host,
              UID: this.user.uid,
              firstName: this.user.firstName,
              lastName: this.user.lastName,
              grant_type: "token",
			  isCollaborator: false,
				collaborator: false,
				collaboratorUID: this.user.uid
            })
            this.$notify({
              group: 'foo',
              title: 'Domain Removal',
              duration: 3000,
              text: res.data.msg,
              type:  'info'
            });
            this.envType = 'live';
          } catch (e) {
            swal({
              title: "Something went wrong!",
              text: 'Please contact support',
              type: "error",
            });
          }
          this.removeStagingRequested = false;
        }
      }
		},
		created() {
			this.accIndex(this.index);
		  if (this.$route.params.env) {
		    this.envType = this.$route.params.env
      }

			if(this.accOrdered.length === 0) {
				this.$store.dispatch("async/stateUpdate", { state: false }, { root: true });
				this.$store.dispatch("hosting/fetchAccounts")
			}
			if(this.$route.query.tab ==='admin_users' || this.$route.query.tab ==='plugins'){
				this.openWordPressTabs = true;
			}
			/* eslint-disable */
			$( document ).ready(function() {
				$('.selectpicker').selectpicker();
			});
			/* eslint-enable */
		},
		updated() {
			/* eslint-disable */
			$( document ).ready(function() {
				$('.selectpicker').selectpicker();
			});
			/* eslint-enable */
		}
	}
</script>

<style lang="scss">
	.square-live {
		width: 15px;
		height: 15px;
		background-color: #2DCA87;
	}

	.square-staging {
		width: 15px;
		height: 15px;
		background-color: #8E45AB;
	}

	.env-name-top {
		font-size: 18px;
		text-transform: uppercase;
	}

	.view-details-wrapper {
		.bootstrap-select {
			vertical-align: super;

			.dropdown-toggle {
				border: none;

				&:hover {
					border: none !important;
				}

				.filter-option {
					.filter-option-inner {
						.filter-option-inner-inner {
							font-size: 14px;
						}
					}
				}
			}
		}
	}

	.heading-text {
		font-weight: bold;
		font-size: 16px;
	}

	.col-mb {
		color: #303952;
	}
	#changeEnv option:disabled{
		background: red;
		color: #fff;
	}
	.view-details-title{
		position: relative;
		top: 4px;
	}
</style>
